export var CreateError;
(function (CreateError) {
})(CreateError || (CreateError = {}));
var CreateRequest = /** @class */ (function () {
    function CreateRequest(props) {
        this.knownErrorCodes = Object.values(CreateError);
        this.method = 'post';
        this.path = 'my/customized-reports';
        this.body = JSON.stringify(props);
    }
    return CreateRequest;
}());
export { CreateRequest };
